import { useAppTranslation } from '@hooks';
import { Controller, useForm } from 'react-hook-form';
import { css } from '@emotion/react';
import { CommonFilters, StateCheckbox } from '@components/inputs';
import { ManagerTypeType, UserActivityState } from '@definitions';
import { ManagerType } from '@pages/types';
import { GetManagersPayloadType } from '@api';
import {
  Button,
  FormItem,
  SelectOption,
  SelectInput,
  Form,
} from 'common-components';
import { FiltersDrawer, FiltersDrawerFooter } from '@components/display';

type FiltersManagersPropsType = {
  data: ManagerType[]
  visible: boolean
  onClose: () => void
  onParamsChange: (params: GetManagersPayloadType) => void
};

const FiltersManagers = ({ visible, onClose, onParamsChange }: FiltersManagersPropsType) => {
  const { translate } = useAppTranslation();
  const { handleSubmit, control } = useForm<GetManagersPayloadType>();

  const onSubmit = (data: GetManagersPayloadType) => {
    onParamsChange && onParamsChange(data);
    onClose();
    return data;
  };

  return (
    <FiltersDrawer open={visible} onClose={onClose}>
      <Form
        onReset={() => {
          control._reset();
          onSubmit({ model: {} });
        }}
        onFinish={handleSubmit(onSubmit)}
        css={drawerContentStyle}
      >
        <CommonFilters control={control} />

        <Controller
          name={'model.type'}
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.role')}>
              <SelectInput
                mode={'multiple'}
                value={field.value}
                onChange={field.onChange}
                css={fullWidthStyle}
              >
                {Object.entries(ManagerTypeType).map(([id, label]) => (
                  <SelectOption key={id} value={Number(id)}>
                    {label}
                  </SelectOption>
                ))}
              </SelectInput>
            </FormItem>
          )}
        />
        <Controller
          name={'model.activity'}
          control={control}
          render={({ field }) => (
            <FormItem label={translate('common.state')}>
              <StateCheckbox
                values={UserActivityState}
                labelTxKey={'userActivity'}
                preset={'user-status'}
                inputProps={{
                  onChange: field.onChange,
                  value: field.value,
                }}
              />
            </FormItem>
          )}
        />

        <FiltersDrawerFooter>
          <Button htmlType="reset">{translate('common.buttons.cancel')}</Button>
          <Button type="primary" htmlType="submit">
            {translate('common.buttons.apply')}
          </Button>
        </FiltersDrawerFooter>
      </Form>
    </FiltersDrawer>
  );
};

const drawerContentStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const fullWidthStyle = css`
  width: 100%;
`;

export default FiltersManagers;
